import { Sparkles, Star } from "lucide-react";

/**
 * Bloco da avaliação do cliente (estrelas + ratings por dimensão + comentário).
 * Se `dimensions` for fornecido (config da campanha), respeita a ORDEM e usa
 * o `label` configurado pelo lojista no lugar de capitalize(key).
 */
export function PedidoAvaliacao({ pedido, dimensions = [] }) {
  if (pedido.review_rating_avg == null) return null;
  const ratings = pedido.review_ratings || {};
  const entries = orderRatings(ratings, dimensions);

  return (
    <div className="rounded-lg border border-amber-400/30 bg-amber-50 dark:bg-amber-500/5 p-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="text-xs font-semibold flex items-center gap-1.5 text-amber-700 dark:text-amber-300">
          <Sparkles className="w-3.5 h-3.5" /> Avaliação do cliente
        </p>
        <div className="inline-flex items-center gap-1 text-amber-500">
          {[1, 2, 3, 4, 5].map((n) => (
            <Star
              key={n}
              className={`w-4 h-4 ${n <= Math.round(Number(pedido.review_rating_avg) || 0) ? "fill-current" : "opacity-30"}`}
              strokeWidth={1.5}
            />
          ))}
          <span className="text-sm font-extrabold ml-1">
            {Number(pedido.review_rating_avg).toFixed(1).replace(".", ",")}
          </span>
          <span className="text-[10px] opacity-70">/ 5</span>
        </div>
      </div>
      {entries.length > 1 && (
        <div className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1">
          {entries.map(([k, v, label]) => (
            <div key={k} className="flex items-center justify-between text-[11px]">
              <span className="text-muted-foreground truncate">{label}</span>
              <span className="inline-flex items-center gap-0.5 shrink-0">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star
                    key={n}
                    className={`w-2.5 h-2.5 text-amber-500 ${n <= Number(v) ? "fill-current" : "opacity-30"}`}
                    strokeWidth={1.5}
                  />
                ))}
              </span>
            </div>
          ))}
        </div>
      )}
      {pedido.review_comment && (
        <p className="mt-2 text-xs italic text-foreground/80 leading-snug whitespace-pre-wrap break-words">
          "{pedido.review_comment}"
        </p>
      )}
    </div>
  );
}

/** Ordena `ratings` conforme dimensions e usa label da campanha; órfãs no fim. */
function orderRatings(ratings, dimensions) {
  const out = [];
  const seen = new Set();
  for (const d of dimensions || []) {
    if (d.key && ratings[d.key] != null) {
      out.push([d.key, ratings[d.key], d.label || cap(d.key)]);
      seen.add(d.key);
    }
  }
  for (const [k, v] of Object.entries(ratings)) {
    if (!seen.has(k)) out.push([k, v, cap(k)]);
  }
  return out;
}

const cap = (s) => (s || "").charAt(0).toUpperCase() + (s || "").slice(1);
